<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'pages.client.readersCard.accessNeededTitle' | translate }}
    </h4>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    @if (isLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isLoading"></app-spinner>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="mb-3">
          <label class="form-label lna" for="restrictedAccessJustification">
            {{ 'pages.client.readersCard.restrictedAccessJustification' | translate }}
            <span class="required-field">*</span>
          </label>
          <div class="textarea-wrapper">
            <textarea
              class="form-control lna"
              id="restrictedAccessJustification"
              [ngClass]="{
                invalid: this.shouldRenderError('restrictedAccessJustification')
              }"
              type="text"
              formControlName="restrictedAccessJustification"
              name="restrictedAccessJustification"
              maxlength="{{ maxFieldLength }}"></textarea>
            <p
              class="length"
              [ngClass]="{
                invalid: restrictedAccessJustification?.value?.length > maxFieldLength
              }">
              {{ restrictedAccessJustification?.value?.length || 0 }}/{{ maxFieldLength }}
            </p>
          </div>
          @if (this.shouldRenderError('restrictedAccessJustification') && restrictedAccessJustification?.errors) {
            @if (restrictedAccessJustification?.errors?.['required']) {
              <small class="error-message">
                {{ 'components.form.errorRequired' | translate }}
              </small>
            } @else if (restrictedAccessJustification?.errors?.['minlength']) {
              <small class="error-message">
                {{
                  'components.form.minLength'
                    | translate: { minLength: restrictedAccessJustification?.errors?.['minlength']['requiredLength'] }
                }}
              </small>
            } @else if (restrictedAccessJustification?.errors?.['maxlength']) {
              <small class="error-message">
                {{
                  'components.form.maxLength'
                    | translate
                      : {
                          maxLength: restrictedAccessJustification?.errors?.['maxlength']['requiredLength']
                        }
                }}
              </small>
            }
          }
        </div>
      </form>
    }
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isLoading" (click)="handleSave()" type="button">
      {{ 'pages.service.visitRoom.summary.save' | translate }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'pages.service.visitRoom.summary.cancel' | translate }}
    </button>
  </div>
</ng-template>

<button class="edit" (click)="open(content)">
  <img src="assets/images/edit-icon.svg" alt="edit" />
  {{ 'pages.service.visitRoom.summary.edit' | translate }}
</button>
